<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M5.81171 5.25V6.03125H3.74178C2.74225 6.03125 1.90402 6.78588 1.79939 7.77991L0.483597 20.2799C0.362208 21.4331 1.26642 22.4375 2.42599 22.4375H18.5726C19.7322 22.4375 20.6364 21.4331 20.515 20.2799L19.1992 7.77991C19.0946 6.78588 18.2563 6.03125 17.2568 6.03125H15.1867V5.25C15.1867 2.66117 13.088 0.5625 10.4992 0.5625C7.91037 0.5625 5.81171 2.66117 5.81171 5.25ZM10.4992 2.125C8.77332 2.125 7.37421 3.52411 7.37421 5.25V6.03125H13.6242V5.25C13.6242 3.52411 12.2251 2.125 10.4992 2.125ZM7.37421 10.7188C7.37421 12.4446 8.77332 13.8438 10.4992 13.8438C12.2251 13.8438 13.6242 12.4446 13.6242 10.7188V9.9375C13.6242 9.50603 13.974 9.15625 14.4055 9.15625C14.8369 9.15625 15.1867 9.50603 15.1867 9.9375V10.7188C15.1867 13.3076 13.088 15.4062 10.4992 15.4062C7.91037 15.4062 5.81171 13.3076 5.81171 10.7188V9.9375C5.81171 9.50603 6.16148 9.15625 6.59296 9.15625C7.02443 9.15625 7.37421 9.50603 7.37421 9.9375V10.7188Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgBuy',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>